<!-- Spinner while slas are being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the sla list. Click below try again.
    <button hc-button size="lg" (click)="loadSLAs()">Reload SLAs</button>
</div>

<div class="admin-slas-table-container" [hidden]="loadError || loading">
    <h2> <hc-icon fontSet="fa" fontIcon="fa-file-text"></hc-icon> SLAs </h2>
    <div class="admin-slas-table-action-bar">
        <button hc-button (click)="openAddEditModal(addEditSLAModal, false)">Add SLA</button>
        <hc-search-bar #searchbar placeholder="Search SLAs" (triggerSearch)="applyFilter($event)"
            class="admin-slas-search"></hc-search-bar>
    </div>
    <table hc-table [borders]="false" class="admin-slas-table" [dataSource]="dataSource" hcSort>
        <!-- ID Column -->
        <ng-container hcColumnDef="id">
            <th hc-index-cell *hcHeaderCellDef hc-sort-header id="idHeader">ID</th>
            <td hc-index-cell *hcCellDef="let element">{{ element.slaid }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Description Column -->
        <ng-container hcColumnDef="description">
            <th hc-header-cell *hcHeaderCellDef id="descriptionHeader">Description</th>
            <td hc-cell *hcCellDef="let element" [innerHTML]="element.description | sanitizeHtml"></td>
        </ng-container>

        <!-- Icon Actions Column -->
        <ng-container hcColumnDef="actions" justify="center">
            <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
            <td hc-cell *hcCellDef="let element">
                <div class="hc-table-actions">
                    <span hcMenuIcon class="fa fa-trash hc-action-ico" hcTooltip="Remove sla"
                        (click)="removeSLA(element)"></span>
                    <span hcMenuIcon class="fa fa-pencil hc-action-ico" hcTooltip="Edit sla"
                        (click)="openAddEditModal(addEditSLAModal, true, element)"></span>
                </div>
            </td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminSLAsDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminSLAsDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No slas meet your search criteria.</span>
    </div>

    <hc-pagination [length]="adminSLAsListLength" [pageSize]="adminSLAsPageSize"
        [hidden]="loadError || loading"></hc-pagination>
</div>

<ng-template #addEditSLAModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>{{ data.edit ? 'Edit' : 'Add' }} SLA</hc-modal-header>
        <hc-modal-body>
            <form [formGroup]="adminSLAControl" class="admin-sla-form">
                <hc-form-field>
                    <hc-label>Name:</hc-label>
                    <input hcInput formControlName="name" placeholder="Enter name" class="name-input"
                        [required]="true" />
                    <hc-error>A name is required</hc-error>
                </hc-form-field>
                <label class="hc-form-field-label">
                    <hc-label>Description:</hc-label>
                </label>
                <quill-editor class="content-editor" formControlName="description"
                        placeholder="Enter description" [modules]="quillConfig"
                        [styles]="quillStyles"></quill-editor>
            </form>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button hc-button buttonStyle="primary"
                [disabled]="!adminSLAControl.dirty || !adminSLAControl.valid"
                (click)="data.edit ? editSLA() : addSLA()">
                {{ data.edit ? 'Update' : 'Add' }}
            </button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>